import { File } from '@core/objects/file';
import { AmsFile } from '@core/objects/ams-file';

export const SIGNATURE_DEPENDENT_MENU_ACTIONS = [
    'download'
];

export interface FilesListItemMenuClick {
    key: string;
    file: File;
}

export interface AmsFilesListItemMenuClick {
    key: string;
    file: AmsFile;
}